module.exports = __webpack_public_path__ + "img/Logo_Mar.addee6b4.png";